/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import { Home, Visibility, Mail, Lock, EuroSymbol } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="https://dekilo.gitlab.io"
          color="transparent"
          className={classes.navLink}
        >
          <Home className={classes.icons} /> Accueil
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="#product"
          color="transparent"
          className={classes.navLink}
        >
          <Visibility className={classes.icons} /> Comment ça marche ?
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="#pricing"
          color="transparent"
          className={classes.navLink}
        >
          <EuroSymbol className={classes.icons} /> Tarifs
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href={`mailto:${process.env.REACT_APP_MAIL}
          ?subject=[Contact]  
          &body=Tapez votre message`}
          color="transparent"
          className={classes.navLink}
        >
          <Mail className={classes.icons} /> Contact
        </Button>
      </ListItem>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx